import React from 'react'
import SalesStatisticOne from './child/SalesStatisticOne';
import LatestRegisteredOne from './child/LatestRegisteredOne';
import AppointmentStatusChart from './child/AppointmentStatusChart';
import UnitCountOne from './child/UnitCountOne';

const DashBoardLayerOne = () => {

    return (
        <>
            {/* UnitCountOne - İstatistik Kartları */}
            <UnitCountOne />

            <section className="row gy-4 mt-1">
                {/* SalesStatisticOne - Gelir Trendi */}
                <SalesStatisticOne />

                {/* AppointmentStatusChart - Randevu Durumları */}
                <AppointmentStatusChart />

                {/* LatestRegisteredOne - Son Organizasyonlar */}
                <LatestRegisteredOne />
            </section>
        </>
    )
}

export default DashBoardLayerOne